
import React, { useEffect, useState } from 'react';
import "./SwitchSection.css";


const SwitchSection = (props) => {
/*
  const handleMenuClick = (content) => {
    setSelectedContent(content);
  };*/

  const [selected, setSelected] = useState("");  //necessary?
  const [content, setContent] = useState(<div>default</div>);  


  useEffect(() => {
    setSelectedContent(selected);
  }, [selected]);


    const content1 = (<div>
    <p>Content 1</p>
    </div>)

    const content2 = (<div>
    <p>Content 2</p>
    </div>)

    const content3 = (<div>
    <p>Content 3</p>
    </div>)


  function shownContent(selected) {
    /*
    switch (selected) {
      case "0":
        return content1;
      case "1":
        return content2;
      case "2":
        return content3;
      default:
        return content1;
    }*/

    let content_index = 0;
    


    try{

      if (selected){
        content_index = parseInt(selected); 
      }

      else {  //default will be first item
        content_index = 0;
      }
      return props.content[content_index];

    }

    catch(err){
      console.log(err);
    }
  };


  function setSelectedContent(item) {
    setSelected(item);
    setContent(shownContent(item));
  }


  const reverseContent = (
    <div className='switch-section-with-title'>
      <div style={{fontSize: "1.5em"}}>
      {props.title}
      </div>
      <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray", marginTop: "-0.75em"}}></hr>
    <div className="switch-section">
    <div className="switch-section-titles">
        {Object.keys(props.titles).map((item) => (
            
            <div className='switch-section-title' key={item} onClick={() => setSelectedContent(item)}>
                {props.titles[item]}
                <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray"}}></hr>
            </div>
            )
            )}
        </div>
        <div className='switch-content'>{content}</div>
        </div>
        </div>
  );

  const regularContent = (
    <div className='switch-section-with-title'>
      <div style={{fontSize: "1.5em"}}>
      {props.title}
      </div>
      <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray", marginTop: "-0.75em"}}></hr>
    <div className="switch-section">
    <div className='switch-content'>{content}</div>
    <div className="switch-section-titles">
        {Object.keys(props.titles).map((item) => (
            
            <div className='switch-section-title' key={item} onClick={() => setSelectedContent(item)}>
                {props.titles[item]}
                <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray"}}></hr>
            </div>
            )
            )}
        </div>
        
        </div>
        </div>
  );

  
  //content can be before or after the section titles depending on the status of props.reverse
  return (
    <div className="SwitchSection">
        {props.reverse ? <div>{regularContent}</div> : <div>{reverseContent}</div>}

    </div>
  );
};


export default SwitchSection;